import getReducer from '../getReducer'
import assign from 'object-assign'

// 新闻管理
import {NEWS_LIST_REQUEST, NEWS_LIST_SUCCESS, NEWS_LIST_FAILURE} from '../../action/content/news'
import {NEWS_INSERT_REQUEST, NEWS_INSERT_SUCCESS, NEWS_INSERT_FAILURE} from '../../action/content/news'
import {NEWS_UPDATE_REQUEST, NEWS_UPDATE_SUCCESS, NEWS_UPDATE_FAILURE} from '../../action/content/news'
import {NEWS_DELETE_REQUEST, NEWS_DELETE_SUCCESS, NEWS_DELETE_FAILURE} from '../../action/content/news'

// 新闻源管理
import {NEWS_SOURCE_LIST_REQUEST, NEWS_SOURCE_LIST_SUCCESS, NEWS_SOURCE_LIST_FAILURE} from '../../action/content/news'
import {NEWS_SOURCE_INSERT_REQUEST, NEWS_SOURCE_INSERT_SUCCESS, NEWS_SOURCE_INSERT_FAILURE} from '../../action/content/news'
import {NEWS_SOURCE_UPDATE_REQUEST, NEWS_SOURCE_UPDATE_SUCCESS, NEWS_SOURCE_UPDATE_FAILURE} from '../../action/content/news'

// 招聘管理
import {RECRUITMENT_LIST_REQUEST, RECRUITMENT_LIST_SUCCESS, RECRUITMENT_LIST_FAILURE} from '../../action/content/recruitment'
import {RECRUITMENT_INSERT_REQUEST, RECRUITMENT_INSERT_SUCCESS, RECRUITMENT_INSERT_FAILURE} from '../../action/content/recruitment'
import {RECRUITMENT_UPDATE_REQUEST, RECRUITMENT_UPDATE_SUCCESS, RECRUITMENT_UPDATE_FAILURE} from '../../action/content/recruitment'
import {RECRUITMENT_DELETE_REQUEST, RECRUITMENT_DELETE_SUCCESS, RECRUITMENT_DELETE_FAILURE} from '../../action/content/recruitment'



const initState = {
  showLoading: false,
  // 新闻
	news: {
		data: [],
		page: 1,
		total: 0,
		pageSize: 10
	},
  // 新闻源
  source: {
    list: [],
    page: 1,
		total: 0,
		pageSize: 10
  },
  // 招聘
	recruitment: {
		data: [],
		page: 1,
		total: 0,
		pageSize: 10
	},
}

// 内容管理模块
function content(state = initState, action) {
	switch (action.type) {
    // =================> 新闻管理 <=======================
    // 新闻列表
		case NEWS_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_LIST_SUCCESS:
			return assign({}, state, {
				  news: assign({}, state.news, action.response.result),
          showLoading: false
        }
			)
		case NEWS_LIST_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 添加新闻
    case NEWS_INSERT_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_INSERT_SUCCESS:
			return assign({}, state, {showLoading: false})
		case NEWS_INSERT_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 编辑新闻
    case NEWS_UPDATE_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_UPDATE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case NEWS_UPDATE_FAILURE:
			return assign({}, state, {showLoading: false})
      
    // 删除新闻 
    case NEWS_DELETE_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_DELETE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case NEWS_DELETE_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // =================> 新闻源管理 <=======================
    // 列表
		case NEWS_SOURCE_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_SOURCE_LIST_SUCCESS:
			return assign({}, state, {
				  source: assign({}, state.source, action.response.result),
          showLoading: false
        }
			)
		case NEWS_SOURCE_LIST_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 添加源
    case NEWS_SOURCE_INSERT_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_SOURCE_INSERT_SUCCESS:
			return assign({}, state, {showLoading: false})
		case NEWS_SOURCE_INSERT_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 编辑源
    case NEWS_SOURCE_UPDATE_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEWS_SOURCE_UPDATE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case NEWS_SOURCE_UPDATE_FAILURE:
			return assign({}, state, {showLoading: false})

    // =================> 招聘管理 <=======================
    // 招聘列表
		case RECRUITMENT_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_LIST_SUCCESS:
			return assign({}, state, {
				  recruitment: assign({}, state.recruitment, action.response.result),
          showLoading: false
        }
			)
		case RECRUITMENT_LIST_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 添加招聘信息
    case RECRUITMENT_INSERT_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_INSERT_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_INSERT_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 编辑招聘信息
    case RECRUITMENT_UPDATE_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_UPDATE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_UPDATE_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 删除招聘信息
    case RECRUITMENT_DELETE_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_DELETE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_DELETE_FAILURE:
			return assign({}, state, {showLoading: false})
      
		default:
			return state
	}
}

export default getReducer(content);


// WEBPACK FOOTER //
// ./src/reducer/content/index.js